import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskSendToGtNetService } from './send-to-gtnet-service/task-send-to-gt-net.service';
import { TaskGetGtNetCalculationService } from './get-gtnet-calculation-service/task-get-gtnet-calculation.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    TaskSendToGtNetService,
    TaskGetGtNetCalculationService
  ],
})
export class GTNetModule {}
